import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';


const actualidad = {
	state: {
		noticias : '',
		promociones : '',
		noticiaDestacada : '',
		proyectos : [],
	},
	getters: {
		categoriaNoticias : (state) => {

			let noticias = state.noticias;

			if(!!noticias){

				let categorias = new Array();

				noticias.forEach( noticia => {
					if(!categorias.some(c => c.slug == noticia.categoria.slug )){
						categorias.push(noticia.categoria)
					}
				});

				return categorias;
			}
		},
		getNoticias : state =>{
			return state.noticias;
		},
		getpromociones : state =>{
			return state.promociones;
		},
		getNoticiasFiltradas : state => {

			return (filtro) => {

				let searchIn = ['titulo', 'entradilla']

				let noticias = state.noticias;

				let filtradas;

				if(!!noticias){

					filtradas = noticias.filter(noticia => {

						let can = false;

						searchIn.forEach(where => {
							(noticia[where].toLowerCase().includes(filtro.search.toLowerCase())) ? can = true : '';
						});

						return (can) ? noticia : '';
					});

					(!!filtro.categoria) ? filtradas = filtradas.filter(noticia => noticia.categoria.slug == filtro.categoria) : '';
				}

				return filtradas;

			}
		},
		getDestacadas : state =>{
			let destacadas;
			if(!!state.noticias){
				destacadas = state.noticias.filter(e => e.destacada == 1).slice(0,2);
			}
			return destacadas;
		},
		getHasNoticias : state => {
			return (!!state.noticias);
		},
		getNoticiaDestacada : state => {
			return state.noticiaDestacada;
		},
		getProyectos : state => {
			return state.proyectos;
		},
		getProyectosType: state => (type = null) => {
			if (type === 'empresa') {
				return state.proyectos.filter(proyecto => proyecto.company === '1');
			} else {
				return state.proyectos.filter(proyecto => !proyecto.company || proyecto.company === '0');
			}
		}
	},
	actions: {
		requestNoticias : ({commit},) => {
			return new Promise((resolve, reject) => {

				axios.get(`/api/entries/es/noticias`)
				.then(response => {
					commit('setNoticias', response.data.entries);
					resolve(true);
				})
				.catch(error => reject(error));

			});
		},
		requestNoticiasCategorias : ({commit},cat) => {
			return new Promise((resolve, reject) => {

				axios.get(`/api/entries/es/noticias/${cat}`)
				.then(response => {
					
					resolve(response.data.entries);
				})
				.catch(error => reject(error));

			});
		},
		requestNoticia : ({}, slug) => {

			return new Promise((resolve, reject) => {

				axios.get(`/api/entries/es/noticia/${slug}`)
				.then(response => {
					resolve(response.data);
				})
				.catch(err => reject(error));

			});
		},
    	requestNoticiaDestacada: ({commit}) => {
    		return new Promise((resolve, reject) => {
		 		axios.get(`/api/entries/es/noticias`, {
					params: {
						priority: 1,
						page: 1,
						size: 1
					}
				}).then((response) => {
                	commit("setNoticiaDestacada", response.data.entries[0]);
                	resolve(response.data);
            	}).catch((error) => reject(error));
    	  	});
    	},
		requestBaseLegal : ({}, slug) => {

			return new Promise((resolve, reject) => {

				axios.get(`/api/entries/es/base-legal/${slug}`)
				.then(response => {
					resolve(response.data);
				})
				.catch(err => reject(error));

			});
		},
		requestPromociones : ({commit},) => {
			return new Promise((resolve, reject) => {

				axios.get(`/api/entries/es/promociones`)
				.then(response => {
					commit('setPromociones', response.data.entries);
					resolve(true);
				})
				.catch(error => reject(error));

			});
		},
		requestPromocion : ({commit}, slug) => {

			return new Promise((resolve, reject) => {

				axios.get(`api/entries/es/promocion/${slug}`)
				.then(response => {
					resolve(response.data);
				})
				.catch(err => reject(error));

			});
		},
		requestProyectos : ({commit},) => {
			return new Promise((resolve, reject) => {
				axios
          .get(`/api/entries/es/proyectos`)
          /* 				axios
          .get(`/api/entries/es/proyectos`, {
            params: {
              page: 1,
              size: 1,
            },
          }) */
          .then((response) => {
            commit("setProyectos", response.data.entries);
            resolve(true);
          })
          .catch((error) => reject(error));
			});
		},
	},
	mutations: {
		setNoticias : (state, noticias) => {
			state.noticias = noticias;
		},
		setPromociones : (state, promociones) => {
			state.promociones = promociones;
		},
		setNoticiaDestacada : (state, noticiaDestacada) => {
			state.noticiaDestacada = noticiaDestacada;
		},
		setProyectos : (state, proyectos) => {
			state.proyectos = proyectos;
		}
	}
}

export default actualidad;



// WEBPACK FOOTER //
// ./src/store/actualidad.js